export enum NotificationWrapperType {
    DatabaseItem = 'database-item',
    WorkspaceAppAccessRequest = 'workspace-app-access-request',
    WorkspacePermissionRequest = 'workspace-permission-request',
}
